import moment from "moment";


export const changeDateFormat = (date) => moment(date).format("YYYY-MM-DD");

export const changeMonthFormat = (date) => moment(date).format("MM");
export const changeYearFormat = (date) => moment(date).format("YYYY");

export const disableFutureDates = (current) => current && current > moment().endOf('day');

export const NAME = "Sri Vasavi Thanga Maligai"
export const WEBSITE = "www.srivasavithangamaligai.com"
export const ADDRESS = "5/39,Main Road,"
export const LOCATION = "PALACODE - 636 808,."
export const DIST = "DHARMAPURI DIST."
export const NUMBER = "+91 9842874874"
export const WNUMBER = "+91 7200574874"
export const EMIL = "srivasavithangamaligai@gmail.com"
export const STATE = "Tamil Nadu."

export const validatePassword = (_, value) => {
    const hasLetter = /[a-z]/.test(value);
    const hasCapitalLetter = /[A-Z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSymbol = /[@$!%*?&]/.test(value);
    const isValidLength = value.length >= 6 && value.length <= 20;

    if (value.trim().length === 0) {
        return Promise.resolve();
    }

    // if (!hasLetter) {
    //     return Promise.reject('Password must contain at least one letter');
    // }

    // if (!hasCapitalLetter) {
    //     return Promise.reject('Password must contain at least one capital letter');
    // }

    // if (!hasNumber) {
    //     return Promise.reject('Password must contain at least one number');
    // }

    // if (!hasSymbol) {
    //     return Promise.reject('Password must contain at least one symbol');
    // }

    if (!isValidLength) {
        return Promise.reject('Password must be between 6 and 20 characters');
    }

    return Promise.resolve();
};


export const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
        if (!value || getFieldValue('appPassword') === value) {
            return Promise.resolve();
        }
        return Promise.reject('The two passwords do not match');
    },
});
